import React, { useEffect, useState } from 'react';
import { apiClient } from '../api/client';

interface EventTask {
  id: string;
  title: string;
  status: string;
}

interface EventTaskCardProps {
  onOpen: () => void;
  refreshKey?: number;
}

const styles: Record<string, React.CSSProperties> = {
  button: {
    padding: '0.85rem 1rem',
    backgroundColor: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    transition: 'all 0.2s',
    textAlign: 'left' as const,
    width: '100%',
  },
  icon: {
    fontSize: '1.5rem',
    lineHeight: 1,
    flexShrink: 0,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  label: {
    fontSize: '0.85rem',
    fontWeight: 600,
    color: '#0f2d1f',
    marginBottom: '2px',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  description: {
    fontSize: '0.75rem',
    color: '#666',
    lineHeight: 1.3,
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1a6b3c',
    color: '#fff',
    fontSize: '0.7rem',
    fontWeight: 700,
    borderRadius: '10px',
    minWidth: '20px',
    height: '20px',
    padding: '0 6px',
  },
};

const CARD_COLOR = '#1a6b3c';

export function EventTaskCard({ onOpen, refreshKey }: EventTaskCardProps) {
  const [taskCount, setTaskCount] = useState<number>(0);

  useEffect(() => {
    apiClient<EventTask[]>('/event-tasks/my-tasks')
      .then((tasks) => setTaskCount(tasks.length))
      .catch(() => setTaskCount(0));
  }, [refreshKey]);

  return (
    <button
      style={styles.button}
      onClick={onOpen}
      onMouseEnter={(e) => {
        const el = e.currentTarget;
        el.style.borderColor = CARD_COLOR;
        el.style.boxShadow = `0 2px 8px ${CARD_COLOR}22`;
      }}
      onMouseLeave={(e) => {
        const el = e.currentTarget;
        el.style.borderColor = '#e0e0e0';
        el.style.boxShadow = 'none';
      }}
      aria-label={`Weekend Event Tasks: ${taskCount} tasks assigned to you`}
    >
      <span style={styles.icon}>📋</span>
      <div style={styles.content}>
        <div style={styles.label}>
          Weekend Event Tasks
          {taskCount > 0 && <span style={styles.badge}>{taskCount}</span>}
        </div>
        <div style={styles.description}>View your assigned event tasks</div>
      </div>
    </button>
  );
}
